import { Lang } from 'types';

export const langMapper: Record<string, Lang> = {
    ru: Lang.Ru,
    en: Lang.En,
};
